<template>
  <router-view></router-view>
</template>
<style scoped>

</style>
<script>
    export default {
        data() {
            return {

            };
        },
        created(){
        },
        mounted() {

        },
        beforeDestroy() {

        },
        methods: {

        }
    };
</script>
